import React from "react";
import { Box, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

function EquipmentCard({
  children,
  step,
  title,
  button,
  onClick,
  permission,
  error,
}) {
  return (
    <div className="equipment-card">
      <div className={`equipment-card-icon ${permission ? "pass" : ""}`}>
        {permission ? <CheckIcon fontSize="large" /> : <span>{step}</span>}
      </div>
      <h2>{title}</h2>
      {children}
      {error ? (
        <p
          role="alert"
          className="equipment-card-error"
          style={{
            color: "#c62828",
            fontSize: "0.85rem",
            margin: "8px 16px 0",
            textAlign: "center",
            lineHeight: 1.35,
          }}
        >
          {error}
        </p>
      ) : null}
      <Box sx={{ p: 3 }}>
        <Button
          variant="contained"
          color={error ? "error" : "primary"}
          size="large"
          onClick={onClick}
          className="button"
        >
          {error ? `Try ${button}` : button}
        </Button>
      </Box>
    </div>
  );
}

export default EquipmentCard;
